import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  elevatedSurfaceBoxShadow,
  transition,
} from '../style-settings'

export const useExternalSiteLinkBarStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      display: 'flex',
      width: '100%',
      marginTop: theme.spacing(2),
    },
    rowDivider: {
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1),
      width: '100%',
      boxSizing: 'border-box',
      padding: theme.spacing(1.5, 2.5),
      marginBottom: 0,
      backgroundColor: `${theme.palette.primary.main}08`,
      border: `1px solid ${theme.palette.primary.main}30`,
      borderRadius: theme.shape.borderRadius * 2,
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 600,
      fontSize: '0.9375rem',
      transition,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.main}15`,
        borderColor: theme.palette.primary.main,
        transform: 'translateY(-2px)',
        boxShadow: elevatedSurfaceBoxShadow,
      },
    },
    icon: {
      fontSize: '1.25rem',
      flexShrink: 0,
    },
  })
)
